export const ErrorMessages = {
  proveedor: {
    ProveedorRequired: "El nombre del proveedor es requerido.",
    EmailRequired: "El correo es requerido.",
    EmailFormatIncorrect:
      "El formato del correo electrónico debe ser nombre@ejemplo.com.",
    PhoneRequired: "El teléfono es requerido, a 10 dígitos.",
    PhoneLengthIncorrect: "El número de teléfono debe de tener 10 dígitos",
    NumberLicensesRequired: "Debe asignarle al proveedor al menos una cuenta.",
  },
  destino: {
    IdProveedorRequired: "El proveedor es requerido.",
    NamePartnerRequired: "El nombre de la empresa de destino es requerida.",
    PersonTypeRequired: "El tipo de persona es requerida.",
    RFCRequired: "El RFC es requerido.",
    RFCFsFormatIncorrect:
      "El RFC debe tener en total 13 caracteres de los cuales, los primeros 4 caracteres son letras, los siguientes 6 caracteres son números y los siguientes 3 caracteres son números, letras o combinados",
    RFCMoFormatIncorrect:
      "El RFC debe tener en total 12 caracteres de los cuales, los primeros 3 caracteres son letras, los siguientes 6 caracteres son números y los siguientes 3 caracteres son números, letras o combinados",
    AddressRequired: "La dirección es requerida.",
  },
  usuario: {
    Nombre: "El nombre del proveedor es requerido.",
    ApellidoPaterno: "El apellido parterno es requerido",
    ApellidoMaterno: "El apellido materno es requerido",
    Correo: "El formato del correo electrónico debe ser nombre@ejemplo.com.",
    Celular: "El teléfono es requerido, a 10 dígitos.",
    IdPerfil: "El perfil es requerido",
    ContraseñasDiferentes: "Las contraseñas no son iguales",
    ContraseñaLongitud: "La contraseña debe tener mínimo {0} y máximo {1}",
    ContraseñaMayuscula: "La contraseña requiere al menos una MAYÚSCULA",
    ContraseñaNumero: "La contraseña requiere al menos un Número",
    ContraseñaCaracter: "La contraseña requiere al menos un caracter especial",
    CodigoProveedor: "El código de registro debe ser de 8 caracteres.",
    CorreosDiferentes: "Los correos no son iguales",
    Captcha: "Captcha incorrecto",
    ContraseñaRequerida: "La contraseña es requerida",
    ContraseñasIguales: "La nueva contraseña debe de ser distinta a la actual"
  },
  envio: {
    NoGuium: "El No. de guía debe tener mínimo, máximo 17 caracteres.",
    GuiumNotFound:
      "Lo sentimos, No. de guía no encontrado. Revise el número e intente nuevamente",
    destinationRequired: "El campo destino de entrega es requerido",
    shippingDescriptionRequired: "El campo Detalles del envió es requerido",
    estimatedArrivalDateRequired:
      "El campo fecha prevista de entrega de guías es requerido",
      incorrectDate:
      "Es necesario escribir correctamente el campo fecha prevista de entrega de guías",
    details: {
      invoiceShipNumberRequired:
        "El campo No. de remisión de factura es requerido",
      purchaseOrderNumberRequired:
        "El campo No. de orden de compra es requerido",
      purchaseOrderNumberLengthIncorrect:
        "El campo No. de orden debe tener mínimo, Máximo 10 dígitos",
      posicionPurchaseOrderRequired:
        "El campo posición de orden de compra es requerido",
      quantityBundlesRequired: "El campo cantidad de bultos es requerido",
      quantityBundlesMinPermitted:
        "La cantidad de bultos ingresados debe de ser al menos de 1",
      quantityMerchandiseRequired:
        "El campo cantidad de mercancía es requerido",
      quantityMerchandiseMinPermitted:
        "La cantidad de mercancía ingresados debe de ser de al menos 1",
    },
  },
  embarque: {
    numeroCartaPorte: "El número de carta porte es requerida",
  },
};
